import request from "../utils/http";

/**
 * 客户管理相关API接口
 */

/**
 * 获取客户列表
 * @param {Object} data - 查询参数
 * @param {string} data.enterpriseName - 企业名称（可选）
 * @param {string} data.taxId - 税号（可选）
 * @param {string} data.cusId - 客户编号（可选）
 * @param {boolean} data.isMe - 是否查询我的客户
 * @returns {Promise<AxiosResponse>}
 */
export function CusBaseList(data = {}) {
  const params = {
    isMe: true,
    ...data
  };

  return request({
    url: '/cusBase/getList',
    method: 'post',
    data: params
  });
}

/**
 * 更新客户信息
 * @param {Object} data - 客户信息
 * @param {string} data.cusId - 客户编号（主键）
 * @param {string} data.enterpriseName - 企业名称
 * @param {string} data.taxId - 税号
 * @returns {Promise<AxiosResponse>}
 */
export function CusBaseUpdate(data) {
  return request({
    url: '/cusBase/CusBaseUpdate',
    method: 'post',
    data: data
  });
}

/**
 * 添加客户信息
 * @param {Object} data - 客户信息
 * @param {string} data.enterpriseName - 企业名称
 * @param {string} data.taxId - 税号
 * @returns {Promise<AxiosResponse>}
 */
export function CusBaseAdd(data) {
  return request({
    url: '/cusBase/addCusBase',
    method: 'post',
    data: data
  });
}

/**
 * 获取客户详情
 * @param {Object} data - 查询参数
 * @param {string} data.cusId - 客户编号（推荐使用）
 * @param {string} data.enterpriseName - 企业名称（兼容旧版本）
 * @returns {Promise<AxiosResponse>}
 */
export function CusBaseDetail(data) {
  // 优先使用cusId，兼容旧版本使用enterpriseName
  const identifier = data.cusId || data.enterpriseName;
  const url = data.cusId
    ? `/cusBase/getDetailById/${data.cusId}`
    : `/cusBase/getDetailByName/${data.enterpriseName}`;

  return request({
    url: url,
    method: 'get'
  });
}

/**
 * 删除客户信息
 * @param {Object} data - 删除参数
 * @param {string} data.identifier - 客户编号或税号
 * @returns {Promise<AxiosResponse>}
 */
export function CusBaseDelete(data) {
  return request({
    url: '/cusBase/delete',
    method: 'post',
    data: data
  });
}

/**
 * 获取渠道商客户列表
 * @param {Object} data - 查询参数
 * @returns {Promise<AxiosResponse>}
 */
export function getChannelCus(data) {
  return request({
    url: '/cusBase/getChannelCus',
    method: 'post',
    data: data
  });
}

/**
 * 批量删除客户
 * @param {Array<string>} identifiers - 客户编号或税号数组
 * @returns {Promise<AxiosResponse>}
 */
export function CusBaseBatchDelete(identifiers) {
  return request({
    url: '/cusBase/batchDelete',
    method: 'post',
    data: { identifiers }
  });
}

/**
 * 导出客户数据
 * @param {Object} data - 导出参数
 * @returns {Promise<AxiosResponse>}
 */
export function CusBaseExport(data = {}) {
  return request({
    url: '/cusBase/export',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
}

/**
 * 获取客户统计信息
 * @returns {Promise<AxiosResponse>}
 */
export function GetCustomerStatistics() {
  return request({
    url: '/cusBase/getStatistics',
    method: 'get'
  });
}

/**
 * 测试数据库连接和表结构
 * @returns {Promise<AxiosResponse>}
 */
export function TestDatabase() {
  return request({
    url: '/cusBase/testDatabase',
    method: 'get'
  });
}


